export const requestOptions = {
  PAGINATION_DEFAULT_PAGE: 1,
  PAGINATION_DEFAULT_PER_PAGE: 10,
  PAGINATION_DEFAULT_PER_PAGE_LARGE: 20
}
